const select = function select(elem) {
  return document.querySelector(elem);
};

const selectAll = function selectAll(elem) {
  return Array.from(document.querySelectorAll(elem));
};

const isScrolledIntoView = function isScrolledIntoView(elem) {
  const docViewTop = window.pageYOffset;
  const docViewBottom = docViewTop + window.outerHeight;
  const windowInnerHeight = window.innerHeight;

  const elemTop = elem.offsetTop;
  const trigger = elemTop + windowInnerHeight / 2;

  return docViewBottom >= trigger;
};

export { select, selectAll, isScrolledIntoView };
